import Checkbox from "../../audi-ui-components/Checkbox";
import Disclaimer from "../../components/Disclaimer";
import {
  consentLabel,
  optinLabel
} from './CVOConstants';
import { DEFAULT_THEME } from "../../constants";

const StepConsent = ({ values, errors, touched, setFieldValue, setFieldTouched, theme = DEFAULT_THEME }) => {
  return (<>
    <hr className="my-5" />
    <Checkbox name="consent"
      label={consentLabel}
      checked={!!values.consent}
      value=""
      onChange={(v,e) => { setFieldValue('consent', e.target.checked); }}
      onBlur={() => { setFieldTouched('consent'); }}
      isInvalid={errors.consent && touched.consent}
      invalidMessage={errors.consent}
      className="form-field"
      theme={theme === "dark" ? "light" : null}
    />
    <Checkbox name="optIn"
      label={optinLabel}
      checked={!!values.optIn}
      value=""
      onChange={(v,e) => { setFieldValue('optIn', e.target.checked); }}
      onBlur={() => { setFieldTouched('optIn'); }}
      isInvalid={errors.optIn && touched.optIn}
      invalidMessage={errors.optIn}
      className="form-field"
      theme={theme === "dark" ? "light" : null}
    />
    <Disclaimer />
  </>);
};

export default StepConsent;
